import type { NormalizedProvidedDetails } from '@ballerine/common';

import { ProvidedDetailsContent as SharedProvidedDetailsContent } from '@/components/templates/shared';

type ProvidedDetailsProps = {
  providedDetails?: NormalizedProvidedDetails | null;
};

export const ProvidedDetailsContent: React.FC<ProvidedDetailsProps> = ({ providedDetails }) => {
  return <SharedProvidedDetailsContent providedDetails={providedDetails} />;
};
